import React, {useState} from 'react';
import {MenuLateralAA} from '../menuLateralAA/MenuLateralAA';
import {ModalActivarServicio} from './ModalActivarServicio';
import {ModalDesactivarServicio} from './ModalDesactivarServicio';
import {ModalGenerarInformes} from './ModalGenerarInformes';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import {useSessionStore} from '../../hooks/useSessionStore';

export const ContentBodyGenerarDocumentos = (props) => {
	const {MenuLateralAux, chageMenuLateralAux} = props;
	/* Using the useSessionStore hook to set the state of the UsuarioContext. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	const [EstadoServicio, setEstadoServicio] = useState(false);

	const [EstadoModal, setEstadoModal] = useState(0);

	/**
	 * It sets the state of the modal to 2.
	 */
	const activarServicio = () => {
		setEstadoModal(2);
	};
	/**
	 * It sets the state of the modal to 3.
	 */
	const generarInformes = () => {
		setEstadoModal(3);
	};
	/**
	 * It sets the state of the modal to 1.
	 */
	const desactivarServicio = () => {
		setEstadoModal(1);
	};

	return (
		<>
			{
				<MenuLateralAB
					seleccionado={5}
					MenuLateralAux={MenuLateralAux}
					chageMenuLateralAux={chageMenuLateralAux}
				/>
			}
			<div className='ContentGenerarDocumentos'>
				{EstadoModal === 1 ? (
					<ModalDesactivarServicio setEstadoModal={setEstadoModal} />
				) : EstadoModal === 2 ? (
					<ModalActivarServicio setEstadoModal={setEstadoModal} />
				) : EstadoModal === 3 ? (
					<ModalGenerarInformes setEstadoModal={setEstadoModal} />
				) : null}

				<div className='centrador'>
					<div className='centradoGenerarInformes'>
						<p className='negro'>
							<b>
								A través de la función de informes de empresa, se reciben
								mensualmente estudios de mercado que favorecen el ritmo de
								crecimiento de la empresa a través de análisis exhaustivos y la
								posibilidad de predicciones sobre el futuro del mercado. Las
								variables incluyen, pero no se limitan, a recomendaciones de
								servicios susceptibles de implementar ShareCare, estadísticas de
								fidelidad de clientela y parámetros de comportamiento como clicks,
								ventas, carrito medio y perfil del cliente medio.
								<br />
								<br />
								<br />
								La función conlleva una tarifa de 10 euros mensuales.
							</b>
						</p>
						{EstadoServicio ? (
							<div className='botonesGenerarInforme'>
								<div
									className='button borrarCuenta'
									onClick={() => desactivarServicio()}
								>
									<b>Desactivar Servicio</b>
								</div>
								<div
									className='button'
									onClick={() => generarInformes()}
								>
									<b>Genenrar informes</b>
								</div>
							</div>
						) : (
							<div
								className='button'
								onClick={() => activarServicio()}
							>
								<b>Activar servicio</b>
							</div>
						)}
					</div>
				</div>
				{/*
        <HeadGenerarDocumentos 
            TipoNotificaciones={TipoNotificaciones}
            setTipoNotificaciones={setTipoNotificaciones}
            cambioNotificaciones={cambioNotificaciones}
        />
     */}
			</div>
		</>
	);
};
